//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Features.js";
let d=[[[1,"BendAngle",0,"Expression",0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"Edge",1,"Edge",0],[1,"FirstDistance",0,"Expression",0],[0,"InsetType",1,0],[1,"Length",0,"Expression",0],[0,"LengthType",1,0],[0,"MatchFaceOption",1,0],[0,"MatchPlane",1,"Plane",0],[1,"Offset",0,"Expression",0],[0,"OffsetType",1,0],[1,"SecondDistance",0,"Expression",0],[0,"Vertex",1,0],[0,"WidthType",1,0]],[[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0],[[],"GetSketch",{R_:{sketch:"Sketch"}},0,0],[[],"EditSketch",{},0,0],[[],"DeleteSketch",{},0,0]],[]];
SPLM.Features.SheetMetal.FlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.FlangeBuilder.InsetTypeOptions = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside"});

SPLM.Features.SheetMetal.FlangeBuilder.LengthTypeOptions = Object.freeze({
    "InsideDimension" : "InsideDimension", "OutsideDimension" : "OutsideDimension", "WebDimension" : "WebDimension"});

SPLM.Features.SheetMetal.FlangeBuilder.OffsetTypeOptions = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.Features.SheetMetal.FlangeBuilder.WidthTypeOptions = Object.freeze({
    "FullEdge" : "FullEdge", "CenterOfEdge" : "CenterOfEdge", "AtEdgeEnd" : "AtEdgeEnd", "FromEdgeEnd" : "FromEdgeEnd", "FromBothEnds" : "FromBothEnds", "Custom" : "Custom"});

SPLM.Features.SheetMetal.FlangeBuilder.MatchFaceOptions = Object.freeze({
    "None" : "None", "UntilSelected" : "UntilSelected"});

export default SPLM;